import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import React, { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { fetchProfile } from '../login/userSlice';
import LoadingFullPage from './LoadingFullPage';

var AuthScreen = function AuthScreen(props) {
  var redirectUrl = props.redirectUrl,
      goBackPage = props.goBackPage;
  var user = useSelector(function (state) {
    return state.user;
  });
  var router = useRouter();
  var dispatch = useDispatch();
  var isMounted = useRef(null);
  var message = props.message,
      closeLoading = props.closeLoading;
  useEffect(function () {
    isMounted.current = true;

    if (!user.isLoggedIn) {
      checkProfile();
    } else {
      closeLoading();
    }

    return function () {
      isMounted.current = false;
    };
  }, []);

  var redirectLogin = function redirectLogin(isLoggedIn) {
    if (!isLoggedIn) {
      var url = redirectUrl ? redirectUrl : '/login';

      if (goBackPage) {
        url += "?redirect=".concat(goBackPage);
      }

      router.push(url);
    } else {
      closeLoading();
    }
  };

  var checkProfile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resultAction, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(fetchProfile());

            case 2:
              resultAction = _context.sent;
              response = unwrapResult(resultAction);
              redirectLogin(response.status);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function checkProfile() {
      return _ref.apply(this, arguments);
    };
  }();

  return __jsx(LoadingFullPage, {
    message: message
  });
};

export default AuthScreen;